import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'idp-guided-navigation-error',
  templateUrl: './guided-navigation-error.component.html',
  styleUrls: ['./guided-navigation-error.component.scss']
})
export class GuidedNavigationErrorComponent {
  toContinueText = '';
  errorMsg = '';
  @Input() set errorMessage(errMsg: string) {
    if (errMsg && errMsg.includes(',')) {
      const parts = errMsg.split(',');
      this.toContinueText = `${parts[0]},`;
      this.errorMsg = parts[1];
    } else {
      this.toContinueText = '';
      this.errorMsg = errMsg || '';
    }
  }

  protected handleErrorMessageClick() {
    const element = document.querySelector('.book-widget-field-error');
    if (!element) return;
    const focusableElement = this.findFocusableElement(element);
    if (focusableElement) {
      (focusableElement as HTMLElement).focus();
      (focusableElement as HTMLElement).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  }

  private findFocusableElement(element: Element) {
    const owRoutePickerElement = element
      .querySelector('.route-picker__wrapper .route-picker__error')
      ?.closest('.route-picker__wrapper');
    const mcRoutePickerElement = element.querySelector(
      '.multi-route-picker__wrapper.error'
    );
    const datePickerTrigger = element.querySelector(
      '.aura-date-picker__trigger'
    );

    return (
      owRoutePickerElement ||
      mcRoutePickerElement ||
      datePickerTrigger ||
      element
    );
  }
}
